import { Component } from '@angular/core';

@Component({
    selector: 'app-skeleton-case',
    templateUrl: './skeleton-case.component.html',
    styleUrls: ['./skeleton-case.component.scss'],
    standalone: false
})
export class SkeletonCaseComponent {
  constructor() {}
}
